// Segmented control in a patient thread's header: "This location" (default) / "All locations"
// (owner 11-04, fax/chat/chatLocation.js). Hidden where the practice has one location (OSA).
import React from "react";
import { THREAD_ALL, THREAD_THIS, threadScopeAvailable } from "./chatLocation";

const OPTIONS = [
  { value: THREAD_THIS, label: "This location" },
  { value: THREAD_ALL, label: "All locations" },
];

export default function ThreadScopeToggle({ value, onChange }) {
  if (!threadScopeAvailable()) return null;
  return (
    <div
      role="group"
      aria-label="Messages shown"
      data-testid="thread-scope"
      className="inline-flex shrink-0 rounded-full border border-[#D5DBEA] bg-[#F7F9FB] p-[2px]"
    >
      {OPTIONS.map((o) => {
        const on = (value === THREAD_ALL ? THREAD_ALL : THREAD_THIS) === o.value;
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={on}
            data-testid={`thread-scope-${o.value}`}
            onClick={() => !on && onChange(o.value)}
            className={`whitespace-nowrap rounded-full px-2 py-[2px] text-[11px] leading-4 font-font1 ${
              on ? "bg-[#24578F] text-white" : "text-[#24578F] hover:bg-[#E8EEF7]"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
